export namespace CancellationReasonConstants {
  export const DRIVER_CANCELLED = 'Driver cancelled';
  export const RIDER_CANCELLED = 'Rider cancelled';
  export const ADMIN_CANCELLED = 'Admin cancelled';
  export const DRIVER_NO_SHOW = 'Driver no show';
  export const RIDER_NO_SHOW = 'Rider no show';
  export const RESERVATION_EXPIRED = 'Reservation expired';
  export const LYFT_DISPATCH_DRIVER_CANCELLED = 'Lyft dispatch driver cancelled';
  export const LYFT_DISPATCH_STATUS_FAILED = 'Lyft dispatch status failed';
  export const LYFT_DISPATCH_STATUS_UNKNOWN = 'Lyft dispatch status unknown';
  export const NO_DRIVER_INTEREST = 'No driver interest';
  export const RIDE_REQUEST_EXPIRED = 'Ride request expired';
  export const WILL_CALL_EXPIRED = 'Will call expired';
  export const RIDE_MODIFIED = 'Ride modified';
  export const RIDE_INCIDENT = 'Incident during ride';
}
